import { getAnalyticsApiUrl } from "../../constants/Urls";
import AnalyticsRequestFilter from "../../models/analytics/AnalyticsRequestFilter";
import { ConversationTrackingTreeBaseNode } from "../../models/analytics/api/ConversationEventTrackingTreeNode";
import { normalizeAnalyticsRequestDateFilter } from '../../utils/engagementAnalyticsTransformers';
import { sendGet } from "./generic";

export const getApplicationConversationTracking = (applicationId: string, filter: AnalyticsRequestFilter) => {
    return sendGet<ConversationTrackingTreeBaseNode>(`/ConversationTracking/application/${applicationId}?${buildQuery(filter)}`, getAnalyticsApiUrl());
}
export const getContentConversationTracking = (applicationId: string, contentId: string, filter: AnalyticsRequestFilter) => {
    return sendGet<ConversationTrackingTreeBaseNode[]>(`/ConversationTracking/content/${applicationId}/${contentId}?${buildQuery(filter)}`, getAnalyticsApiUrl());
}

const buildQuery = (filter: AnalyticsRequestFilter) => {
    const normalizedFilter = normalizeAnalyticsRequestDateFilter(filter);
    const startDate = normalizedFilter.startDate;
    const endDate = normalizedFilter.endDate;

    let query = `startDate=${startDate}&endDate=${endDate}`;
    if (normalizedFilter.assistants?.length > 0) {
        query += ("&assistants=" + normalizedFilter.assistants.join("&assistants="))
    }
    if (normalizedFilter.userIds?.length > 0) {
        query += ("&userIds=" + normalizedFilter.userIds.join("&userIds="))
    }
    if (normalizedFilter.sessionIds?.length > 0) {
        query += ("&sessionIds=" + normalizedFilter.sessionIds.join("&sessionIds="))
    }
    if (normalizedFilter.deviceTargetIds?.length > 0) {
        query += ("&deviceTargetIds=" + normalizedFilter.deviceTargetIds.join("&deviceTargetIds="))
    }
    if (normalizedFilter.languageIds?.length > 0) {
        query += ("&languageIds=" + normalizedFilter.languageIds.join("&languageIds="))
    }
    return query;
}
